import React from 'react';
import { LeadsListPage } from './LeadsListPage';

export function ProspectsListPage() {
  return <LeadsListPage defaultStatus="NEW" />;
}
